/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { SelfCheckinConfigAsSelfCheckin } from '../../models/self-checkin-config-as-self-checkin';

export interface GetSelfCheckinConfigAsSelfCheckin$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
}

export function getSelfCheckinConfigAsSelfCheckin(http: HttpClient, rootUrl: string, params: GetSelfCheckinConfigAsSelfCheckin$Params, context?: HttpContext): Observable<StrictHttpResponse<SelfCheckinConfigAsSelfCheckin>> {
  const rb = new RequestBuilder(rootUrl, getSelfCheckinConfigAsSelfCheckin.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SelfCheckinConfigAsSelfCheckin>;
    })
  );
}

getSelfCheckinConfigAsSelfCheckin.PATH = '/organization-sites/{organizationSiteKey}/self-checkin/config';
